import { render, staticRenderFns } from "./OnlineCustomUpload.vue?vue&type=template&id=2b94003c&"
import script from "./OnlineCustomUpload.vue?vue&type=script&lang=js&"
export * from "./OnlineCustomUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports